import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const QNXT = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showMedicareChoice, setShowMedicareChoice] = useState(false);
  const [memberName, setMemberName] = useState({ firstName: '', lastName: '' });
  const [memberType, setMemberType] = useState('');
  const [memberState, setMemberState] = useState(''); // Add state for storing member state from API
  
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    try {
      console.log('Redirecting to /redirect');
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      console.error('Error during redirect:', err);
      if (typeof console !== 'undefined') console.log(err);
    }   
    const queryParams = new URLSearchParams(location.search);
    const MemberId = queryParams.get('memqnxtid');
    const MemberFirstName = queryParams.get('MemberFirstName');
    const MemberLastName = queryParams.get('MemberLastName');
    const SystemId = queryParams.get('SystemId');
    const UserId = queryParams.get('UserId');
    const Module = queryParams.get('Module') || '';
    if (MemberFirstName && MemberLastName) {
      setMemberName({ firstName: MemberFirstName, lastName: MemberLastName });
    }   
    fetchQnxtDetails(MemberId, MemberFirstName, MemberLastName, SystemId, UserId, Module);
  }, [location]);
  const fetchQnxtDetails = async (MemberId, MemberFirstName, MemberLastName, SystemId, UserId, Module) => {
    try {
      console.log('API Call Parameters:', {
        MemberId: MemberId || '',
        MemberFirstName: MemberFirstName || '',
        MemberLastName: MemberLastName || '',
        SystemId: SystemId || '',
        UserId: UserId || '',
        Module: Module || ''
      });
     
      const response = await axios.get(`${API_URL}/api/QNXT/MemberDetails`, {
        params: {
            MemberId: MemberId || '',
            MemberFirstName: MemberFirstName || '',
            MemberLastName: MemberLastName || '',
            SystemId: SystemId || '',
            UserId: UserId || '',
            Module: Module || 'QNXT'
        }
      });
      console.log('API Response:', response.data);

      // Add AIOS log
      console.log('AXIOS Log:', {
        MemberId,
        MemberFirstName,
        MemberLastName,
        SystemId,
        UserId,
        Module
      });

      // Extract member state and other data from API response
      if (response.data && response.data.data) {
        const memberData = response.data.data;
        
        // Store the member state from API response
        setMemberState(memberData.memberState || '');
        console.log('Member State from API:', memberData.memberState);

        // Check if member requires type selection or has direct redirection URL
        if (memberData.requiresTypeSelection) { 
          console.log('Member requires type selection');
          setLoading(false);
          console.log('Showing Medicare choice');
          setShowMedicareChoice(true);
        } 
        else if (memberData.redirectionUrl) {
          console.log('Redirecting to URL:', memberData.redirectionUrl);
          window.location.href = memberData.redirectionUrl;        
        } 
        else {
          setLoading(false);
          setError('qnxt');
        }
      } else {
        setLoading(false);
        setError('qnxt');
      }
    } catch (error) {
      console.error('Error fetching QNXT details:', error);
      setError('qnxt');
      setLoading(false);
    }
  };

  // Combined handler for both Medicare and Medicaid
  const handleMemberTypeClick = (memberTypeSelected) => {
    setLoading(true);
    setShowMedicareChoice(false);
    setMemberType(memberTypeSelected);
    
    // Extract parameters from URL - these are available throughout component lifecycle
    const queryParams = new URLSearchParams(location.search);
    const memberId = queryParams.get('MemberID') || queryParams.get('memqnxtid') || '';
    const state = memberState || '';
    
    console.log(`${memberTypeSelected} API Call Parameters:`, {
        memberId: memberId,
        state: state,
        memberType: memberTypeSelected
    });

    // Add validation matching API controller requirements
    if (!memberId) {
        console.error(`Member ID is required for ${memberTypeSelected} environment`);
        setError('qnxt');
        setLoading(false);
        return;
    }

    axios.get(`${API_URL}/api/QNXT/QnxtLink`, {
        params: {
            memberId: memberId,
            state: state,
            memberType: memberTypeSelected,
            Module: 'QNXT'
        }
    })
    .then(response => {
        setLoading(false);
        console.log(`${memberTypeSelected} API Response:`, response.data);
        
        // Enhanced response handling to match API response structure
        if (response.data && response.data.data && response.data.data.redirectionUrl) {
            console.log(`Redirecting to ${memberTypeSelected} QNXT URL:`, response.data.data.redirectionUrl);
            window.location.href = response.data.data.redirectionUrl;
        } else {
            console.error(`No ${memberTypeSelected} redirection URL found in response`);
            setError('qnxt');
        }
    })
    .catch(error => {
        console.error(`Error fetching ${memberTypeSelected} URL:`, error);
        
        // Enhanced error handling
        if (error.response && error.response.data) {
            console.error(`${memberTypeSelected} API Error details:`, error.response.data);
            
            if (error.response.status === 404) {
                const errorMsg = memberTypeSelected === 'Medicaid' 
                    ? 'Medicaid QNXT link not found - SNP details may be missing'
                    : 'Medicare QNXT link not found for this member';
                console.error(errorMsg);
            } else if (error.response.status === 400) {
                console.error(`Invalid ${memberTypeSelected} request parameters:`, error.response.data.message);
            } else if (error.response.status === 500) {
                console.error(`Server error while generating ${memberTypeSelected} QNXT link`);
            }
            
            if (error.response.data.message) {
                console.error('API Error Message:', error.response.data.message);
            }
        }
        setError('qnxt');
        setLoading(false);
    });
  };

  // Wrapper functions for button clicks
  const handleMedicareClick = () => handleMemberTypeClick('Medicare');
  const handleMedicaidClick = () => handleMemberTypeClick('Medicaid');
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      {error && (
        <div style={{
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          color: '#333',
          lineHeight: '1.6',
          border: '1px solid #4a90e2',
          borderRadius: '4px',
          padding: '30px 40px',
          backgroundColor: '#fff',
          width: 'calc(100vw - 40px)',
          height: 'calc(100vh - 40px)',
          margin: '20px',
          position: 'fixed',
          top: '0',
          left: '0',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box'
        }}>
          <ErrorPage errorType="qnxt" />
        </div>
      )}
      
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            border: '1px solid #e0e0e0',
            margin: '20px'
          }}>
            <div style={{
              marginBottom: '20px',
              fontSize: '16px',
              color: '#333'
            }}>
              Loading...
            </div>
            <img src={LoadingImage} alt="Loading" style={{
              width: '50px', 
              height: '50px'
            }} />
          </div>
        </div>
      )}

      {showMedicareChoice && (
        <div style={{
          textAlign: 'center',
          margin: '0 auto',
          padding: '40px 20px',
          maxWidth: '600px',
          width: '100%'
        }}>
          <h1 style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#2c5aa0',
            marginBottom: '20px',
            fontFamily: 'Arial, sans-serif',
            lineHeight: '1.4'
          }}>
            Select QNXT Environment
          </h1>
          
          <p style={{
            fontSize: '16px',
            color: '#555',
            lineHeight: '1.6',
            marginBottom: '30px',
            fontFamily: 'Arial, sans-serif'
          }}>
            We found the Member <strong style={{color: '#2c5aa0'}}>{memberName.firstName} {memberName.lastName}</strong> in Medicare and Medicaid environments. 
            Please select below environment you wish to go to
          </p>
          
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}>
            <button 
              onClick={handleMedicareClick}
              style={{
                backgroundColor: '#ffffff',
                color: '#2c5aa0',
                border: '2px solid #2c5aa0',
                borderRadius: '8px',
                padding: '12px 32px',
                fontSize: '14px',
                fontWeight: '600',
                fontFamily: 'Arial, sans-serif',
                cursor: 'pointer',
                minWidth: '140px',
                transition: 'all 0.2s ease',
                outline: 'none'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#2c5aa0';
                e.target.style.color = '#ffffff';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(44, 90, 160, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.color = '#2c5aa0';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              Medicare
            </button>
            
            <button 
              onClick={handleMedicaidClick}
              style={{
                backgroundColor: '#ffffff',
                color: '#2c5aa0',
                border: '2px solid #2c5aa0',
                borderRadius: '8px',
                padding: '12px 32px',
                fontSize: '14px',
                fontWeight: '600',
                fontFamily: 'Arial, sans-serif',
                cursor: 'pointer',
                minWidth: '140px',
                transition: 'all 0.2s ease',
                outline: 'none'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#2c5aa0';
                e.target.style.color = '#ffffff';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(44, 90, 160, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.color = '#2c5aa0';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              Medicaid/MMP
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QNXT;
        